import React from "react";

const LancamentoInfo = () => {
    return <h1>Lançamento Info</h1>
}

export default LancamentoInfo;